<template>
	<v-container>
		<h1>Nuevo</h1>
		<v-row>
			<v-col>
				<Pacientes />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Pacientes from '@/components/Pacientes'
export default {
	name: 'Nuevo',
	components: {
		Pacientes
	},
	data() {
		return {
			nombreUsuario: '',
			esAdmin: false,
		}
	},
	mounted: function() {
		if(!this.$session.exists()){
			this.$router.push('/login')
		} else {
			this.nombreUsuario = this.$session.get('nombre')
			this.esAdmin = this.$session.get('esAdmin')
			if(!this.esAdmin){
				this.$router.push('/')
			}
		}
	}
}
</script>
